export default "__VITE_ASSET__ae6b2af3__"